import { Auth } from "aws-amplify";
import { AppContext } from "context/app-context";
import { useContext } from "react";

const useLogout = () => {
  const { adminCreds } = useContext(AppContext);
  const logout = async () => {
    if (!adminCreds?.HASURA_SECRET) {
      await Auth.signOut();
    }
    window.location.href = "/";
  };
  return [logout];
};

export default useLogout;
